module.exports = __webpack_public_path__ + "static/img/about2.e5778dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/about2.jpg
// module id = loiX
// module chunks = 3